import { render, staticRenderFns } from "./Certs.vue?vue&type=template&id=e8a060ae&scoped=true"
import script from "./Certs.vue?vue&type=script&lang=js"
export * from "./Certs.vue?vue&type=script&lang=js"
import style0 from "./Certs.vue?vue&type=style&index=0&id=e8a060ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a060ae",
  null
  
)

/* custom blocks */
import block0 from "./Certs.vue?vue&type=custom&index=0&blockType=i18n&locale=ru&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e8a060ae', component.options)
    } else {
      api.reload('e8a060ae', component.options)
    }
    module.hot.accept("./Certs.vue?vue&type=template&id=e8a060ae&scoped=true", function () {
      api.rerender('e8a060ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "site/src/views/certs/Certs.vue"
export default component.exports